/*
 * Constants defined using SCREAMING_SNAKE_CASE to adhere to Google's Typescript style guide.
 * See: https://google.github.io/styleguide/tsguide.html#naming-rules-by-identifier-type
 */

// earthquake/chart-data

export const EARTHQUAKE_SURVEY_2022 =
	"0918 池上地震-花東地區地震認知與避難行為調查 (2023)";
export const EARTHQUAKE_SURVEY_2022_EN =
	"Household Survey of 0918 Earthquake Disaster: \nPreparedness and Response in Hualien and Taitung (2022)";
export const THEME_CHART = "主題圖表";
export const THEME_CHART_EN = "Theme chart";

// 四大主題
export const DAILY_DISASTER_PREPARATION = "民眾日常的減災整備";
export const WHAT_PEOPLE_DID_AFTER_THE_CHISHANG_EARTHQUAKE =
	"遇到池上地震！民眾都做了什麼？";
export const LOSSES_FROM_THE_CHISHANG_EARTHQUAKE = "池上地震導致的損失";
export const CHARACTERISTICS_OF_RESPONDENTS_AND_HOUSEHOLDS = "受訪者及家戶特徵";
